import { AppConfig } from './app-config.model';

/**
 * Mapa de configuración por hostname.
 *
 * Reemplaza los archivos environment.ts de Angular para soportar múltiples
 * entornos en un solo build desplegado en Azure Static Web Apps / Front Door.
 * La clave es window.location.hostname; el valor contiene las credenciales MSAL
 * y la URL del API correspondiente a ese entorno.
 *
 * Si se agrega un nuevo entorno (ej. staging), basta con añadir una entrada aquí
 * sin modificar el pipeline de build ni regenerar artefactos.
 *
 * NOTA: el scope de 'construramateconecta.cemex.com' (prod) lleva el sufijo
 * DEV_QA porque ese es el nombre real del scope registrado en Azure AD.
 * Verificar con el equipo de Azure AD si en algún momento se crea un scope
 * exclusivo de producción.
 */
export const DOMAIN_CONFIG: Record<string, AppConfig> = {
    'localhost': {
        apiUrl: 'http://localhost:5011/',
        clientId: '7996264d-2d36-4469-8462-f5467e73cc8b',
        tenantId: 'de98034d-3b58-459d-a48c-c97b35e48125',
        scope: 'api://7996264d-2d36-4469-8462-f5467e73cc8b/api',
        redirectUri: 'https://localhost:4200',
        countryId: 9
    },
    'dev-conectate-maestro-fhhjazanaugxhpd2.z01.azurefd.net': {
        apiUrl: 'https://api-dev.cemexgo.com/v1/csat/conectatemaestro/',
        clientId: 'e89652bc-88f6-4fe0-8288-c9177a8c4b83',
        tenantId: '6ee19001-d0c4-45f8-af8b-ff00f16d07e1',
        scope: 'api://0654509e-1e6c-4766-bf6b-100b768a833e/Conectate_Maestro_API_DEV_QA',
        redirectUri: 'https://dev-conectate-maestro-fhhjazanaugxhpd2.z01.azurefd.net/',
        countryId: 9
    },
    'qa-construramateconecta.cemex.com': {
        apiUrl: 'https://qa-api.cemexgo.com/v1/csat/conectatemaestro/',
        clientId: 'd115e8fc-3a33-4301-9d81-6aaa9d836cf6',
        tenantId: '6ee19001-d0c4-45f8-af8b-ff00f16d07e1',
        scope: 'api://acb6cbab-9f95-49b5-b9f6-28861e20c4a1/Conectate_Maestro_API_DEV_QA',
        redirectUri: 'https://qa-construramateconecta.cemex.com/',
        countryId: 9
    },
    'construramateconecta.cemex.com': {
        apiUrl: 'https://api.cemexgo.com/v1/csat/conectatemaestro/',
        clientId: 'e89652bc-88f6-4fe0-8288-c9177a8c4b83',
        tenantId: '6ee19001-d0c4-45f8-af8b-ff00f16d07e1',
        scope: 'api://acb6cbab-9f95-49b5-b9f6-28861e20c4a1/Conectate_Maestro_API_DEV_QA',
        redirectUri: 'https://construramateconecta.cemex.com/',
        countryId: 9
    }
};
